import { Typography } from '@mui/material'

export default function HeaderTitle() {
  return (
    <>
      <Typography
        fontSize="larger"
        fontWeight="bold"
        sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }}
      >
        سامانه مدیریت فرایند آفاق کسب‌و‌کار
      </Typography>

      <Typography
        fontSize="larger"
        fontWeight="bold"
        sx={{ flexGrow: 1, display: { xs: 'block', md: 'none' } }}
      >
        آفاق کسب‌وکار
      </Typography>
    </>
  )
}
